import {
  type ApiProblemDetails,
  getPayPointsPublicIDScanView,
  type PayPointScanViewDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { skipToken, useQuery } from "@tanstack/react-query";

const PAY_POINT_SCAN_VIEW_QUERY_KEY = "PAY_POINT_SCAN_VIEW";

export const payPointScanViewKeys = {
  all: [PAY_POINT_SCAN_VIEW_QUERY_KEY],
  byId: (publicID?: string | null) => [...payPointScanViewKeys.all, publicID],
};

// Anonymous-safe slim view of a paypoint — only the fields the customer scan flow needs.
// Use this on customer/anonymous pages instead of `usePayPointQuery`, which fetches the
// full InternalPayPointDto and is reserved for authenticated callers.
export const usePayPointScanViewQuery = (publicID?: string | null) =>
  useQuery<PayPointScanViewDto, ApiProblemDetails, PayPointScanViewDto>({
    queryKey: payPointScanViewKeys.byId(publicID),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getPayPointsPublicIDScanView(publicID),
        )
      : skipToken,
  });
